import React from 'react';
import { FormattedMessage } from 'react-intl';
import globalMessages from 'messages';

import { ExtendedRouts } from 'app-constants';
import favorite from 'modules/favorite';

const { FavoriteCount } = favorite.components;

export const favoriteHomeTabs = [
    {
        title: (
            <React.Fragment>
                <FormattedMessage {...globalMessages.upcoming} />

                <FavoriteCount type="upcoming" />
            </React.Fragment>
        ),
        link: ExtendedRouts.FAVORITE_UPCOMING,
    },
    {
        title: (
            <React.Fragment>
                <FormattedMessage {...globalMessages.outrights} />

                <FavoriteCount type="outrights" />
            </React.Fragment>
        ),
        link: ExtendedRouts.FAVORITE_OUTRIGHTS,
    },
    {
        title: <FormattedMessage {...globalMessages.results} />,
        link: ExtendedRouts.FAVORITE_RESULTS,
    },
];
